import { useContext } from 'react'
import { Link } from 'libs/router'
import { useTranslation } from 'libs/i18n'

import { routes } from 'config/routes'
import { DashboardContext } from 'store'
import { CardWrapper, Currency } from 'shared/components'
import { Currency as CurrencyType } from 'shared/types/general.types'
import { EmptyState } from 'shared/components/EmptyState/EmptyState'
import { DashboardCardHeader, DashboardViewAllLink } from '../molecules'

import type { DashboardListProps } from '../types/types'

export const DashboardList = ({
	label,
	title,
	emptyText,
	icon,
	iconBgColor,
	iconColor,
	list = [],
	viewAllTo
}: DashboardListProps) => {
	const { t } = useTranslation()
	const dashboardCtx = useContext(DashboardContext)
	const currency = dashboardCtx?.dashboard?.currency as CurrencyType

	return (
		<CardWrapper className="flex min-w-0 flex-col">
			<DashboardCardHeader
				icon={icon}
				iconBgColor={iconBgColor}
				iconColor={iconColor}
				label={label}
				title={title}
			/>
			{list.length ? (
				<>
					<ul className="flex-1 space-y-2 p-4 sm:p-5">
						{list.map((product) => (
							<li
								key={product.id}
								className="flex items-center justify-between gap-3 rounded-md bg-background p-3">
								<div className="min-w-0">
									<p className="truncate text-[13px] font-semibold">{product.name}</p>
									<Currency
										className="mt-0.5 block text-[11px] text-muted-foreground"
										price={{ amount: product.price, currency }}
									/>
								</div>
								<Link
									to={routes.productEdit(String(product.id))}
									className="shrink-0 rounded-md px-2 py-1 text-[12px] font-semibold text-primary transition-colors hover:bg-primary-soft">
									{t('View')}
								</Link>
							</li>
						))}
					</ul>
					<DashboardViewAllLink to={viewAllTo} />
				</>
			) : (
				<EmptyState icon={icon} text={emptyText} />
			)}
		</CardWrapper>
	)
}
